"use client";

import React, { useState } from 'react';
import ProjectsHero from './components/ProjectsHero';
import ProjectsFilter from './components/ProjectsFilter';
import ProjectCard from './components/ProjectCard';
import IdeaBanner from './components/IdeaBanner';
import ProjectsProcess from './components/ProjectsProcess';
import ProjectsStats from './components/ProjectsStats';


export default function ProjectsClient({ initialProjects = [], pageData = null }) {
  const [activeCategory, setActiveCategory] = useState("All Projects");

  const colors = ["bg-blue-500", "bg-pink-500", "bg-green-500", "bg-purple-500", "bg-orange-500", "bg-yellow-500"];
  
  const mappedProjects = (initialProjects || []).map((p, i) => {
    let imgUrl = p.heroSection?.image?.url || "/assets/img/projects/dakzy/Dakzy cover.png";
    if (imgUrl.startsWith('http')) {
      imgUrl = encodeURI(imgUrl);
    } else if (imgUrl.startsWith('/')) {
      imgUrl = encodeURI(imgUrl);
    } else {
      imgUrl = encodeURI(`/${imgUrl}`);
    }
    
    return {
      id: p._id,
      title: p.name,
      category: p.category || "Web Applications",
      description: p.heroSection?.description || p.overview || "CodeQlik Project",
      image: imgUrl,
      tagColor: colors[i % colors.length],
      link: `/projects/${p.slug}`
    };
  });

  // Extract unique categories from mapped projects if they don't match the mock filter categories
  const dynamicCategories = ["All Projects", ...new Set(mappedProjects.map(p => p.category))];

  const filteredProjects = activeCategory === "All Projects"
    ? mappedProjects
    : mappedProjects.filter(p => p.category === activeCategory);

  return (
    <div className="container mx-auto px-4 md:px-6 py-10 relative z-10 max-w-[1360px]">
      
      {/* Hero Section */}
      <ProjectsHero data={pageData?.heroSection} />

      {/* Filters Section */}
      <ProjectsFilter 
        categories={dynamicCategories} 
        activeCategory={activeCategory} 
        onCategoryChange={setActiveCategory} 
      />

      {/* Projects Grid */}
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
        {filteredProjects.map(project => (
          <ProjectCard key={project.id} project={project} />
        ))}
        {filteredProjects.length === 0 && (
          <div className="col-span-full py-20 text-center text-gray-500">
            No projects found for this category.
          </div>
        )}
      </div>

      {/* Delivery Process Section */}
      <div className="mt-20">
        <ProjectsProcess data={pageData?.processSection} />
      </div>

      {/* Statistics Section (Contains CTA) */}
      <ProjectsStats data={pageData?.statsSection} />

    </div>
  );
}
